// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bB2udcKiE5qOgd {
  display: flex;
  flex-direction: row;
}
.bB2udcKiE5qOgd li {
  margin-top: 2px;
  margin-right: 6px;
}
.bB2udcKiE5qOgd li:first-of-type {
  margin-right: 4px;
}
.bB2udcKiE5qOgd li:first-of-type img {
  width: 21px;
}
.bB2udcKiE5qOgd li,
.bB2udcKiE5qOgd li a {
  width: 24px;
  height: 24px;
}
.bB2udcKiE5qOgd li a {
  display: flex;
  align-items: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"socialShareLinksList": `bB2udcKiE5qOgd`
};
export default ___CSS_LOADER_EXPORT___;
